<template>
  <div>
    <div
      class="header flex justify-between mb-6 relative"
    >
      <div>
        <h1 class="mb-6">Willkommen in der arbogast-Mediathek!</h1>
        <p>
          Hier stellen wir Ihnen AUDIO- und VIDEO-Aufnahmen von Vorträgen,
          Diskussions- und Dialogveranstaltungen kostenlos* zum Nachhören
          zur Verfügung. Die Mediathek wird laufend ergänzt.
        </p>
        <p>
          Wir wünschen gute Unterhaltung.<br>
          * Über freiwillige Spenden freuen wir uns.
        </p>
      </div>
      <div class="flex text-3xl">
        <span
          title="als Boxen anzeigen"
          @click="change_display_type('box')"
          class="cursor-pointer right fa fa-th-large mr-1"
          :class="{ 'text-red-700': display_type === 'box' }"
        ></span>
        <span
          title="als Liste darstellen"
          @click="change_display_type('list')"
          class="cursor-pointer right fa fa-th-list mr-1"
          :class="{ 'text-red-700': display_type !== 'box' }"
        ></span>
        <span
          title="Suchen und Filtern"
          @click="show_filter = !show_filter"
          class="cursor-pointer right fa fa-search ml-4"
        ></span>
        <filter-options v-show="show_filter" @window-close="window_close" />
      </div>
    </div>

    <div class="agenda-list">
      <ul
        class="unstyled"
        :class="{
          'grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4': display_type === 'box',
          '': display_type !== 'box',
        }"
      >
        <!--
        <li v-for="agenda in get_agenda_filtered_by_categories.slice(0,10)"
        -->
        <li
          v-for="agenda in get_filtered"
          :key="agenda.id"
          :class="{
            border: display_type === 'box',
            flex: display_type !== 'box',
          }"
        >
          <!-- {{ agenda.media_files }} -->
          <div v-if="false" class="w-4/4">
            {{ agenda }}
          </div>

          <div
            :class="{
              '': display_type === 'box',
              'mr-1 w-1/4': display_type !== 'box',
            }"
          >
            <div
              v-for="referent in agenda.referents"
              :key="referent.id"
              class="round mb-1 relative"
            >
              <img :src="referent.image" class="w-full" />
              <div
                :class="{
                  small: display_type !== 'box',
                  'pl-4 absolute top-0 right-0 bg-white px-2': display_type === 'box',
                }"
              >
                {{ referent.firstname }} {{ referent.lastname }}
              </div>
            </div>
          </div>

          <div
            :class="{
              'w-3/4': display_type !== 'box',
              'w-1/1 px-4 py-2': display_type === 'box',
            }"
          >
            <div v-if="agenda.video_links">
              <vue-plyr
                v-for="(token, i) in agenda.video_links.split('\n')"
                :key="i"
              >
                <div
                  v-if="true"
                  class="plyr__video-embed"
                  style="margin-bottom: 10px;"
                >
                  <iframe
                    :src="
                      `https://www.youtube.com/embed/${token}?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`
                    "
                    allowfullscreen
                    allowtransparency
                    allow="autoplay"
                  >
                  </iframe>
                </div>
              </vue-plyr>
            </div>

            <span
              v-if="false"
              @click="toggle_playlist(agenda.id)"
              style="float: right; font-size: 22px; cursor: pointer;"
            >
              <i
                v-if="in_playlist(agenda.id)"
                class="fa fa-star text-red-700"
              ></i>
              <i v-else class="fa fa-star-o"></i>
            </span>

            <h3 class="black">{{ agenda.formated_start_date }}</h3>
            <h1>
              <a
                v-if="false"
                data-url="`/programm/agendas/${agenda.id}`"
                :href="`/programm/agendas/${agenda.id}`"
              >
                {{ agenda.title }}
              </a>
              <h3>{{ agenda.title }}</h3>
            </h1>

            <h2 class="subtitle black">{{ agenda.subtitle }}</h2>
            <p v-if="agenda.multimedia_content">
              {{ agenda.multimedia_content }}
            </p>
            <p v-else>{{ agenda.content.slice(0, 200) }} ...</p>
            <div v-for="media in agenda.media_files" :key="media.id">
              <vue-plyr
                v-if="media.file_content_type.match('audio')"
                :options="display_options(agenda)"
                :emit="[ 'progress', 'waiting' ]"
                @waiting="display_progress"
                @progress="display_progress"
              >
                <audio class="audio-player" controls preload="none">
                  <source :src="media.file_path" type="audio/mp3" />
                </audio>
              </vue-plyr>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex"
import FilterOptions from "./filter-options"
import cloneDeep from 'lodash/cloneDeep'

const options = {
        controls: [
          "play-large",
          // 'restart',
          // 'rewind',
          "play",
          // 'fast-forward',
          "progress",
          "current-time",
          'duration',
          "mute",
          // 'volume',
          'captions',
          // 'settings',
          // 'pip',
          // 'airplay',
          "download",
          // 'fullscreen',
        ]
      };

export default {
  data() {
    return {
      show_filter: false,
    }
  },
  computed: {
    ...mapState(["agendas", "playlist", 'display_type']),
    ...mapGetters([
      "get_agenda_filtered_by_categories",
      "get_filtered",
      "in_playlist",
    ]),
    display_options: () => (agenda) => {
      let res = cloneDeep( options )
      console.log( 'entry', options, res )
      if( parseInt( agenda.audio_not_downloadable ) > 0 && res.controls.indexOf( 'download' ) >= 0 ) {
        res.controls.splice( res.controls.indexOf( 'download' ), 1)
      }
      console.log( 'return', res )
      return res
    },

  },
  methods: {
    ...mapActions(["toggle_playlist", 'change_display_type']),
    display_progress(e) {
      // console.log(e.detail.plyr)
    },
    window_close() {
      console.log("window close key pressed")
      this.show_filter = false
    },
  },
  components: {
    FilterOptions,
  },
}
</script>

<style lang="scss">
.plyr--audio .plyr__progress__buffer {
  color: red !important;
}
.right {
  float: right;
}
.mr-1 {
  padding-right: 10px;
}
.agenda-list {
  ul li div {
    .black {
      color: black;
    }
    h1 {
      font-size: 130%;
    }
    h2 {
      font-size: 110%;
    }
    h3 {
      font-size: 90%;
    }
    p {
      font-weight: thin;
      margin-top: 5px;
      margin-bottom: 5px;
    }
  }
}
</style>
